import { render, staticRenderFns } from "./SendTopic.vue?vue&type=template&id=860fd1f8&scoped=true"
import script from "./SendTopic?vue&type=script&lang=js&external"
export * from "./SendTopic?vue&type=script&lang=js&external"
import style0 from "./SendTopic.css?vue&type=style&index=0&id=860fd1f8&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860fd1f8",
  null
  
)

export default component.exports